import { render } from "./App.vue?vue&type=template&id=0617b134"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=0617b134&lang=scss"

import exportComponent from "F:\\work\\angren\\qabul_auniver\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__